<template>
  <section class="slopePage">
    <div class="container">
      <div class="row align-items-center justify-content-between flex-nowrap
                  slopePage__title-wrapper">
        <div class="slopePage__title slopePage__title-withBtn">
          Параметры участка контруклона
        </div>
        <button @click="showDeleteConfirmationModal()"
                class="delete__btn" v-if="this.allSlopes.length !== 1">
          <svg width="19" height="25" viewBox="0 0 19 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 2.91667L18 5.29333M5.73105 3.60667L7.89615 1L12.1461 1.61333L13.349
            4.60333M12.467 12.1933L12.2264 19.5533M6.61321 12.1933L6.85377 19.63M1.56128
            7.74667H17.4386L16.6368 21.7C16.5566 22.9267 15.5141 24 14.2311 24H4.76883C3.40562 24
            2.44336 22.9267 2.36317 21.7L1.56128 7.74667Z" stroke="#999999" stroke-width="2"
                  stroke-miterlimit="22.9256" stroke-linecap="round" stroke-linejoin="round">
            </path>
          </svg>
        </button>
      </div>
      <div class="row slopeForm slopePage__pane">
        <div class="col-12">
          <div class="slopePage__subtitle">
            Форма участка
          </div>
        </div>
        <div class="col-12 slopeForm__box">
          <div v-for="item in slopeForms"
               :key="item.id"
               class="slopeForm__box-item">
            <label class="slopeForm__box-item__btn"
                  :for="item.value"
                  :class="{'slopeForm__box-item__btn--active':
                  slopeFromState.slopeForm === item.value}">
            <input type="radio"
                   :id="item.value"
                   :value="item.value"
                   v-model="slopeFromState.slopeForm"
                   class="slopeForm__box-item__btn__input"
                   @change="updateSlopeForm">
            <img :src="item.src"
                 :alt="item.value"
                 width="100%">
            </label>
          </div>
        </div>
      </div>
      <div class="row align-items-center figure__box slopePage__pane">
        <div class="col-12">
          <div class="slopePage__subtitle slopePage__subtitle-figure">
            Размеры участка
          </div>
        </div>
        <div class="col-lg-4 col-md-4 slopePage__inputs-figure">
          <div v-for="(param, i) in slopeFromState.slopeParams" :key="i" class="input__params-box">
              <div class="input__box input__box-width">
                <span>Ширина, м</span>
                <input type="number"
                       placeholder=""
                       min="1"
                       max="1000"
                       :value="param.width"
                       @input="updateSlopeWidth"
                       ref="inputWidth"
                       class="input__box-input">
              </div>
              <div v-if="'bias1' in param" class="input__box input__box-bias1">
                <span>Смещ<i>ение</i><em>.</em> 1, м</span>
                <input type="number"
                       placeholder=""
                       min="0"
                       max="1000"
                       step="0.1"
                       :value="param.bias1"
                       @input="updateSlopeBias1"
                       ref="inputBias"
                       class="input__box-input">
              </div>
              <div v-if="'ratio' in param" class="select__box">
                <span>Рекомундуемое <br>соотношение <br>диагоналей ромба</span>
                <div class="select__box-overlay">
                  <select @change="updateSlopeRatio"
                          v-model.number="param.ratio"
                          class="select__box-select">
                    <option value="2">1 к 2</option>
                    <option value="3">1 к 3</option>
                    <option value="4">1 к 4</option>
                    <option value="5">1 к 5</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        <div class="col-lg-8 col-md-8 figure__box-right slopePage__figure-figure">
         <div class="figure__box-right__corners figure__box-right__corners--top"></div>
         <div class="figure__box-right__corners figure__box-right__corners--bottom"></div>
          <component
            :is="slopeFromState.slopeForm"
            :slopeParams="slopeFromState.slopeParams"
            :defaultSvgParams="defaultSvgParams">
          </component>
        </div>
      </div>
      <SimilarInputs :slope="slope"
                     :isContr="true"
                     />
    </div>
  </section>
</template>
<script>

import Triangle from './figures/Triangle.vue';
import DoubleSideTriangleHorizontal from './figures/DoubleSideTriangleHorizontal.vue';
import DoubleSideTriangleVertical from './figures/DoubleSideTriangleVertical.vue';
import Rhombus from './figures/Rhombus.vue';
import RectangularTrapezoidHorizontal from './figures/RectangularTrapezoidHorizontal.vue';
import RectangularTrapezoidVertical from './figures/RectangularTrapezoidVertical.vue';
import DoubleSideRectangularTrapezoidVertical
  from './figures/DoubleSideRectangularTrapezoidVertical.vue';
import SimilarInputs from './SimilarInputs.vue';

export default {
  props: {
    slope: Object,
  },
  data() {
    return {
      picked: '',
      isShowDeleteConfirmation: false,
      /* eslint-disable import/no-unresolved */
      /* eslint-disable global-require */
      slopeForms: [
        {
          id: 0,
          value: 'triangle',
          label: 'треугольник',
          src: require('@/assets/img/forms/triangle.svg'),
        },
        {
          id: 1,
          value: 'doubleSideTriangleHorizontal',
          label: 'двухсторонний треугольник горизонтальный',
          src: require('@/assets/img/forms/doubleSideTriangleHorizontal.svg'),
        },
        {
          id: 2,
          value: 'doubleSideTriangleVertical',
          label: 'двухсторонний треугольник вертикальный',
          src: require('@/assets/img/forms/doubleSideTriangleVertical.svg'),
        },
        {
          id: 3,
          value: 'rhombus',
          label: 'ромб',
          src: require('@/assets/img/forms/rhombus.svg'),
        },
        {
          id: 4,
          value: 'rectangularTrapezoidVertical',
          label: 'вертикаьная прямоугольная трапеция',
          src: require('@/assets/img/forms/rectangularTrapezoidVertical.svg'),
        },
        {
          id: 5,
          value: 'rectangularTrapezoidHorizontal',
          label: 'горизонтальная прямоугольная трапеция',
          src: require('@/assets/img/forms/rectangularTrapezoidHorizontal.svg'),
        },
        {
          id: 6,
          value: 'doubleSideRectangularTrapezoidVertical',
          label: 'двухсторонняя вертикальная прямоугольная трапеция',
          src: require('@/assets/img/forms/doubleSideRectangularTrapezoidVertical.svg'),
        },
      ],
      /* eslint-enable import/no-unresolved */
      /* eslint-enable global-require */
    };
  },
  components: {
    Triangle,
    DoubleSideTriangleHorizontal,
    DoubleSideTriangleVertical,
    Rhombus,
    RectangularTrapezoidHorizontal,
    RectangularTrapezoidVertical,
    DoubleSideRectangularTrapezoidVertical,
    SimilarInputs,
  },
  methods: {
    updateSlopeForm() {
      this.$emit('updateSlopeForm', {id: this.slopeId, form: this.slopeFromState.slopeForm});
    },
    updateSlopeWidth(e) {
      if (!isNaN(e.target.valueAsNumber)) {
        this.$store.commit('updateSlopeWidth', {id: this.slopeId, width: e.target.valueAsNumber});
      }
    },
    updateSlopeRatio(val) {
      this.$store.commit('updateSlopeRatio', {id: this.slopeId, ratio: val});
    },
    updateSlopeBias1(e) {
      if (!isNaN(e.target.valueAsNumber)) {
        this.$store.commit('updateSlopeBias1', {id: this.slopeId, bias1: e.target.valueAsNumber});
      }
    },
    changeSlopeLayersCount() {
      this.$store.commit('updateSlopeLayersCount', {
        id: this.slopeId,
        count: this.slope.slopeLayersCount
      });
    },
    changeFixtureCalculation() {
      this.$store.commit('updateFixtureCalculation', {
        id: this.slopeId,
        need: this.slope.fixtureCalculation.need
      });
    },
    changeRoofBaseType() {
      this.$store.commit('updateFixtureCalculationType', {
        id: this.slopeId,
        type: this.slope.fixtureCalculation.type
      });
    },
    changeFixtureCalculationThickness() {
      this.$store.commit('updateFixtureCalculationThickness',
        {id: this.slopeId, val: this.slope.fixtureCalculation.thickness});
    },
    showDeleteConfirmationModal() {
      this.$emit('showDeleteConfirmationModal');
    },
  },
  watch: {
  },
  computed: {
    slopeFromState() {
      return this.$store.getters.getSlope(this.slopeId);
    },
    slopeId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    allSlopes() {
      return this.$store.getters.allSlopes;
    },
    defaultSvgParams() {
      return this.$store.getters.getDafaultSvgParams;
    },
  },
  mounted() {
  },
};
</script>

<style lang="sass">
.select
  &__box
    display: flex
    flex-direction: row
    align-items: center
    justify-content: space-between
    margin-bottom: rem(10)
    +media((margin-top: (320: rem(40), 768: 0)))
    +media((margin-left: (320: 0, 992: rem(30))))
    +media((width: (320: 100%, 992: rem(235))))
    +media((padding-left: (320: calc((100vw - 300px) / 2), 768: 0)))
    +media((padding-right: (320: calc((100vw - 300px) / 2), 768: 0)))
    span
      text-align: left
      font-style: normal
      font-weight: 500
      font-size: rem(12)
      line-height: rem(18)
      color: #999999
    &-select
      background: #FFFFFF
      border: rem(1) solid #D6D6D6
      box-sizing: border-box
      border-radius: rem(4)
      height: rem(40)
      width: rem(80)
      outline: none
      box-shadow: none
      font-family: 'Montserrat', sans-serif
      font-style: normal
      font-weight: 600
      font-size: rem(15)
      line-height: rem(15)
      color: #999999
      padding-left: rem(13)
      -webkit-appearance: none
      -moz-appearance: none
      cursor: pointer
    &-overlay
      position: relative
      &:after
        content: ""
        position: absolute
        top: 50%
        transform: translateY(-50%)
        right: rem(12)
        height: rem(12)
        width: rem(12)
        background-image: url(../assets/img/select.svg)
        background-position: center
        background-repeat: no-repeat
        pointer-events: none
</style>
